import React, {useEffect, useState} from "react";
import zoomImg from "../../../../assets/icons/imgBtn.svg";
import BlogImagePopper from "./BlogImageLarge";
import image1 from "../../../../assets/images/blog10-9.png";
import image2 from "../../../../assets/images/blog10-16.png";
import image3 from "../../../../assets/images/blog10-36.png";
import image4 from "../../../../assets/images/blog10-18.png";
import image5 from "../../../../assets/images/blog10-24.png";
import image6 from "../../../../assets/images/blog10-11.png";
import image7 from "../../../../assets/images/blog10-28.png";

const Blog10 = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const handleRedirect = (url) => {
    window.open(url, "_blank");
  };
  const handleLargeImg = (img) => {
    setSelectedImage(img);
  };
  useEffect(() => {
    if (selectedImage) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [selectedImage]);
  return (
    <div className="MainNewBlog">
      <div className="blogHeader">
        <h2 className="headerBoldText mainHeader">Weekly Market Outlook: March 17, 2025</h2>
      </div>
      <div className="blogContentnew">
        <div className="subHeader">
          <p className="highlightedBoldText">The Wall of Worry Keeps Rising—But is it Time to Climb?</p>
          <div className="contentDivWrapper">
            <div className="contentDiv">
              <p>
                A great comment I heard last week: "When he said Build the Wall, I didn’t realize it was the Wall of Worry!" Markets have been thrown into a blender of stagflation fears, AI-sector
                pullbacks, and global macro uncertainty—but that’s exactly where the best opportunities emerge.
              </p>
              <p>Let’s dive into the key themes and trade setups driving the week ahead.</p>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <p className="highlightedBoldText">Key Market Themes: Stagflation, Central Banks, and the Tesla Chainsaw Massacre</p>

          <div className="contentDivWrapper row_reverse">
            <div className="contentDiv">
              <p className="highlightedText_header">Tesla Chainsaw Massacre</p>
              <p>
                Tesla’s brutal sell-off continues (-15% on Monday, -45% YTD), slashing Elon Musk’s status as the richest man in the world. The AI and tech momentum is hitting a critical pause, and Hon
                Hai’s comments last Friday suggest this might just be a breather rather than a full-blown collapse.
              </p>
            </div>
          </div>
        </div>
        <div className="subHeader">
          <div className="contentDivWrapper row_reverse">
            <div className="contentDiv">
              <p className="highlightedText_header">Geopolitics & Trade Wars</p>
              <p>
                Putin meets with Trump on Tuesday—what’s next for Russia’s pre-arranged exit plan? Meanwhile, BlackRock quietly snapped up two of the five Panama Canal ports from Chinese interests,
                adding to the tensions. The tariff war is heating up, and markets are bracing for deflationary forces from the East.
              </p>
            </div>
            <div className="relatedImg">
              <img
                src={image1}
                alt=""
              />
              <div
                className="zoomBtn"
                onClick={() => handleLargeImg(image1)}
              >
                <button>
                  <img
                    src={zoomImg}
                    alt=""
                  />
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="subHeader">
          <div className="contentDivWrapper ">
            <div className="contentDiv">
              <p className="highlightedText_header">Central Bank Showdown</p>
              <p>
                The BOJ, FOMC, SNB (-25bps expected), and BoE all take center stage this week. The Fed is boxed in by conflicting data—Michigan inflation expectations are at 32-year highs, yet
                consumer confidence is cratering. Markets are pricing in rate cuts, but Powell may have other plans.
              </p>
            </div>
            <div className="relatedImg">
              <img
                src={image2}
                alt=""
              />
              <div
                className="zoomBtn"
                onClick={() => handleLargeImg(image2)}
              >
                <button>
                  <img
                    src={zoomImg}
                    alt=""
                  />
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="subHeader">
          <div className="contentDivWrapper row_reverse">
            <div className="contentDiv">
              <p className="highlightedText_header">China’s Fiscal Stimulus—Underwhelming?</p>
              <p>Beijing is hinting at consumer-side stimulus, but traders expecting a 2009-style "bazooka" might be disappointed. Officials are signaling a slow, steady approach instead.</p>
            </div>
            <div className="relatedImg">
              <img
                src={image3}
                alt=""
              />
              <div
                className="zoomBtn"
                onClick={() => handleLargeImg(image3)}
              >
                <button>
                  <img
                    src={zoomImg}
                    alt=""
                  />
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="subHeader">
          <div className="contentDivWrapper ">
            <div className="contentDiv">
              <p className="highlightedText_header">The US Consumer’s Last Stand</p>
              <p>
                Retail sales print on Monday could make or break near-term Fed expectations. The unemployment outlook remains mixed, and rising stagflationary pressures are fanning recession fears.
              </p>
            </div>
            <div className="relatedImg">
              <img
                src={image4}
                alt=""
              />
              <div
                className="zoomBtn"
                onClick={() => handleLargeImg(image4)}
              >
                <button>
                  <img
                    src={zoomImg}
                    alt=""
                  />
                </button>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper row_reverse">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Technical & Sentiment Analysis: Inflection Point or Just a Correction?</p>

              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    The <span className="highlightedText">S&P 500</span> has pulled back -10% from highs—textbook correction, but not a bear market (-20%). The AI trade is seeing long-overdue exposure
                    resets.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    Fear & Greed Index is at <span className="highlightedText">EXTREME fear </span>levels—usually a contrarian buy signal.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    {" "}
                    Massive <span className="highlightedText">put buying</span> has kept the market pinned, but signs of a reversal are emerging as calls begin to take over.
                  </p>
                </li>
                <li className="themesPointer listImage">
                  <p>
                    <span className="highlightedText">SPX 5650</span> is the new pain point where market makers maximize profits. Watch for a battle around this level.
                  </p>
                  <div className="relatedImg">
                    <img
                      src={image5}
                      alt=""
                    />
                    <div
                      className="zoomBtn"
                      onClick={() => handleLargeImg(image5)}
                    >
                      <button>
                        <img
                          src={zoomImg}
                          alt=""
                        />
                      </button>
                    </div>
                  </div>
                </li>
                <li className="themesPointer listImage">
                  <p>
                    <span className="highlightedText">Tech & Banks sliding together</span>—a rare and dangerous double warning. If financials (XLF) don’t hold, expect broader pain.
                  </p>
                  <div className="relatedImg">
                    <img
                      src={image6}
                      alt=""
                    />
                    <div
                      className="zoomBtn"
                      onClick={() => handleLargeImg(image6)}
                    >
                      <button>
                        <img
                          src={zoomImg}
                          alt=""
                        />
                      </button>
                    </div>
                  </div>
                </li>
                <li className="themesPointer listImage">
                  <p>
                    <span className="highlightedText">Gold at $3,000</span>—a psychological level that attracted heavy selling. Consolidation before the next leg higher?
                  </p>
                  <div className="relatedImg">
                    <img
                      src={image7}
                      alt=""
                    />
                    <div
                      className="zoomBtn"
                      onClick={() => handleLargeImg(image7)}
                    >
                      <button>
                        <img
                          src={zoomImg}
                          alt=""
                        />
                      </button>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper row_reverse">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Last Week’s Recap: Chaos, Tariffs & Flight to Safety</p>

              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Tech wreck:</span> TSLA (-15%), NVDA (-5.1%), Palantir (-10%)—AI exuberance got a harsh reality check.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Retail sector pain: </span> Kohl’s (-26%), Target, Macy’s all warning about consumer pullbacks.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Commodities mixed:</span> Copper & steel prices rallying, but consumer-sensitive materials like plastic are seeing deflationary forces.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Dollar at a major turning point—</span> Trump wants USD down and Yields down first then the stock market will see some love again.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Defensive rotation:</span> Investors moving into EU stocks, selling US exceptionalism trade.
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper row_reverse">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">The Week Ahead: High-Stakes Data & Fed Pivot Watch</p>

              <ul className="pointersSection">
                <h2 className="pointersText">Monday, March 17</h2>
                <li className="themesPointer">
                  <p>US Retail Sales – Key read on the struggling US consumer</p>
                </li>
                <li className="themesPointer">
                  <p>China Industrial Production & Retail Sales – Does Beijing have a growth problem?</p>
                </li>
                <li className="themesPointer">
                  <p>ECB Lagarde Speaks – More hints on rate cut timing?</p>
                </li>
              </ul>
              <ul className="pointersSection">
                <h2 className="pointersText">Tuesday, March 18</h2>
                <li className="themesPointer">
                  <p>German Spending Vote – Massive implications for EU bond markets</p>
                </li>
                <li className="themesPointer">
                  <p> US Building Permits & Housing Starts – Leading indicator for economic health.</p>
                </li>
                <li className="themesPointer">
                  <p> Canadian CPI – Inflation trends in focus.</p>
                </li>
              </ul>
              <ul className="pointersSection">
                <h2 className="pointersText">Wednesday, March 19</h2>
                <li className="themesPointer">
                  <p>BOJ Rate Decision & Outlook – too early to keep hiking rates; waiting for wage rate push?</p>
                </li>
                <li className="themesPointer">
                  <p>FOMC Statement & SEP/Dot Plot – The big one. Will Powell push back against rate cut expectations?</p>
                </li>
              </ul>
              <ul className="pointersSection">
                <h2 className="pointersText">Thursday, March 20</h2>
                <li className="themesPointer">
                  <p>SNB, BoE Rate Decisions – Expect SNB to cut, BoE to hold.</p>
                </li>
                <li className="themesPointer">
                  <p>US Philly Fed, Jobless Claims – Recession or soft landing?</p>
                </li>
                <li className="themesPointer">
                  <p>Nike, FedEx Earnings – Key consumer & global trade indicators.</p>
                </li>
              </ul>
              <ul className="pointersSection">
                <h2 className="pointersText">Friday, March 21</h2>
                <li className="themesPointer">
                  <p>UK and EZ consumer confidence – signs of improvement or bottom up angst?</p>
                </li>
                <li className="themesPointer">
                  <p>EU Leaders Summit – Will they push back on tariffs?</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper row_reverse">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Actionable Takeaways: Where the Smart Money is Looking</p>

              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">SPX 5650-5700 is the battleground</span>– If bulls defend, we could see a squeeze higher
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText"> Tech at a crucial pivot</span>– AI pullback looks like a pause, not a breakdown. Look for NVDA, AAPL stabilization. Nvidia GPU Tech Conference
                    Mar 17-21 San Jose, CA
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Gold remains the hedge </span>– Consolidating around $3,000, but long-term setup still bullish.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US vs. EU trade reversal?</span>– "Sell US, Buy EU" continues as DAX outperforms SPX.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Defensive sectors still in favor</span>– Watch utilities, staples, and healthcare as a safe haven play.
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper ">
            <div className="contentDiv">
              <p className="highlightedBoldText">Final Thoughts</p>
              <p>Markets always bounce back… unless we’re in a 1930s-style depression (spoiler: we’re not). Stay sharp, trade smart, and keep an eye on those key inflection points.</p>
            </div>
          </div>
        </div>
        <div className="button_wrapper">
          <button
            className="gradientButton_small "
            onClick={() => {
              handleRedirect("https://docs.google.com/document/d/1R-d8yelQ6z07zWm-kZHCYRlNh-V3dFBiiWpECdGNKLI/edit?tab=t.0");
            }}
          >
            Read In-Depth Market Outlook
          </button>
        </div>
      </div>
      {selectedImage && (
        <BlogImagePopper
          image={selectedImage}
          onClose={() => handleLargeImg(null)}
        />
      )}
    </div>
  );
};

export default Blog10;
